export default {
    title: '範本庫',
    createTemplate: '建立範本',
    searchPlaceholder: '搜尋範本...',
    showingResults: '顯示 {count} 個結果',
    total: '共',
    sort: '排序',
    all: '全部',
    myTemplates: '我的範本',
    favorites: '收藏',
    allRegions: '全部地區',

    sortByUpdated: '最近更新',
    sortByCreated: '最近建立',
    sortByNameAsc: '名稱 (A-Z)',
    sortByNameDesc: '名稱 (Z-A)',
    types: {
        PATENT_APPLICATION: '專利申請',
        INVENTION_DISCLOSURE: '發明揭露',
        OFFICE_ACTION_RESPONSE: '審查意見答覆',
    },
    regions: { all: '全部地區', USPTO: '美國專利局', EPO: '歐洲專利局', PCT: 'PCT國際申請', CNIPA: '中國專利局', JPO: '日本專利局', KIPO: '韓國專利局' },
    technologyArea: { general: '通用', electrical: '電氣', mechanical: '機械', chemical: '化學', software: '軟體', biotech: '生物技術' },
    preview: '預覽', edit: '編輯', editInfo: '編輯資訊', editContent: '編輯內容', duplicate: '複製', delete: '刪除', favorite: '收藏', unfavorite: '取消收藏', moreActions: '更多操作',
    source: '來源', system: '系統', custom: '自訂', systemTemplate: '系統範本',
    name: '名稱', type: '類型', region: '地區', updated: '更新時間', actions: '操作',
    messages: { fetchListFailed: '取得範本列表失敗', fetchDetailFailed: '取得範本詳情失敗', createSuccess: '範本建立成功', createFailed: '範本建立失敗', updateSuccess: '範本更新成功', updateFailed: '範本更新失敗', deleteSuccess: '範本刪除成功', deleteFailed: '範本刪除失敗', duplicateSuccess: '範本複製成功', duplicateFailed: '範本複製失敗', favoriteSuccess: '收藏成功', favoriteFailed: '收藏失敗', unfavoriteSuccess: '取消收藏成功', unfavoriteFailed: '取消收藏失敗' },
    noTemplates: '暫無範本', noTemplatesDesc: '建立您的第一個範本開始使用', noResults: '未找到匹配的範本', noResultsDesc: '嘗試調整搜尋條件或篩選器',
    dialog: {
        createTemplate: '建立範本',
        createTemplateDesc: '選擇類型並設定名稱，開始建立專業範本',
        templateName: '範本名稱',
        templateNamePlaceholder: '請輸入範本名稱',
        templateType: '範本類型',
        creationMethod: '建立方式',
        blankTemplate: '空白範本',
        blankTemplateDesc: '從零開始建立全新範本',
        copyFromExisting: '複製範本',
        copyFromExistingDesc: '基於現有範本建立',
        selectBaseTemplate: '選擇基礎範本',
        noTemplatesAvailable: '暫無可用範本',
        createAndEdit: '建立並編輯',
        sections: '範本章節',
        cancel: '取消',
        unsavedChangesTitle: '未儲存的修改',
        unsavedChangesMessage: '您有未儲存的修改，確定要關閉嗎？關閉後修改將遺失。',
        discardChanges: '放棄修改',
        continueEditing: '繼續編輯',
        lastUpdated: '最後更新',
        noContent: '暫無內容',
        // Level selection (Super Admin only)
        level: '可見性',
        adminOnly: '僅管理員',
        systemLevel: '系統級',
        userLevel: '用戶級',
        systemLevelDesc: '對所有用戶可見',
        userLevelDesc: '僅自己可見',
        // Description
        description: '描述',
        descriptionPlaceholder: '簡要描述此範本的用途和使用場景...',
        optional: '可選',
        // Word import
        importFromWord: '從 Word 匯入',
        importFromWordDesc: '從 .docx 檔案提取章節',
        uploadWordFile: '上傳 Word 文件',
        uploadWordAction: '拖放 .docx 檔案到此處或點擊上傳',
        uploadWordHint: '支援包含標題樣式的 .docx 檔案',
        parsing: '正在解析文件...',
        parseSuccess: '成功解析 {count} 個章節',
        parseFailed: '解析文件失敗',
        parsedSections: '已解析章節 ({count})',
    },

    // Template Editor
    templateEditor: {
        back: '返回',
        untitledTemplate: '未命名範本',
        clickToEdit: '點擊編輯',
        templateType: '範本類型',
        region: '地區',
        technologyArea: '技術領域',
        from: '來源',
        visibility: '可見性',
        private: '私有',
        library: '範本庫',
        saveTemplate: '儲存範本',
        aiInstructions: 'AI 指令',
        aiInstructionsDesc: '為每個章節設定 AI 指令，引導 AI 按要求生成符合預期的內容。',
        addSection: '新增章節',
        sectionTitle: '章節標題',
        insert: '插入',
        delete: '刪除',
        selectInstruction: '選擇指令',
        aiInstructionPlaceholder: '輸入此章節的 AI 指令...',
        description: '描述',
        descriptionPlaceholder: '描述範本的用途和主要特點...',
        // Level
        level: '可見性',
        // Collapse/Expand buttons
        collapseAll: '全部收起',
        expandAll: '全部展開',
        // Section prompt editor
        aiInstruction: 'AI 指令',
        chars: '字元',
        fromLibrary: '從庫中選擇',
        remove: '刪除',
        required: '必填',
        // Section names
        sections: {
            title: '標題',
            crossReference: '相關申請交叉引用',
            fieldOfInvention: '發明領域',
            background: '背景技術',
            summary: '發明內容',
            briefDescription: '附圖說明',
            detailedDescription: '具體實施方式',
            claims: '權利要求',
            abstract: '摘要',
            newSection: '新章節',
        },
        types: {
            patentApplication: '專利申請',
            inventionDisclosure: '發明交��書',
            officeActionResponse: '審查意見答覆',
        },
        messages: {
            nameRequired: '請輸入範本名稱',
            updateSuccess: '範本更新成功',
            saveSuccess: '範本儲存成功',
            saveFailed: '儲存範本失敗',
            loadFailed: '載入範本失敗',
            insertedPlaceholder: '已插入 [{title}]',
        },
        systemTemplate: '系統範本',
        systemTemplateReadOnly: '系統範本為唯讀模式',
        readOnly: '唯讀',
        clickToEditName: '點擊標題修改',
    },
};
